export enum InputErrorEnum {
  codeAlreadyUsed = "err.codeAlreadyUsed",
  codeConfirm = "err.codeConfirm",
  duplicity = "err.duplicity",
  email = "err.email",
  general = "err.general",
  maxNum = "err.maxNum",
  minNum = "err.minNum",
  maxStr = "err.maxStr",
  minStr = "err.minStr",
  notSupported = "err.notSupported",
  oneStateMinimum = "err.oneStateMinimum",
  phone = "err.phone",
  required = "err.required",
  requiredCheckbox = "err.requiredCheckbox",
  requiredMultiple = "err.requiredMultiple",
  tooBig = "err.tooBig",
  resizeError = "err.resizeError",
  tooMuch = "err.tooMuch",
  validChars = "err.validChars",
  noCateg = "err.noCateg",
  noCategN = "err.noCategN",

  errIBAN = "err.errIBAN",
  errIdHolder = "err.errIdHolder",
  errNum = "err.errNum",
  errDateSimple = "err.dateSimple",
  errDateWithSlash = "err.dateWithSlash",
  errDateWithSlashAndNa = "err.dateWithSlashAndNa",
  noForeignLangCode = "err.noForeignLangCode",
  validRegNum = "err.validRegNum",
  validVs = "err.validVs",
  errRegNum = "err.errRegNum",
}

export interface InputErrors {
  [key: string]: InputError | InputErrors;
}

export type InputError = string | InputErrorEnum | undefined;
